export enum ChatReadStatus {
  READ = 'read',
  UNREAD = 'unread',
}
